<template>
  <div id="FuelInventoryClearingSummaryReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Fuel Inventory Clearing Summary</div>
          <div class="web-action-btn btn-groups text-right">
            <a
              href="javascript:void(0)"
              class="btn btn-secondary"
              v-on:click="exportReports()"
            >
              <i class="fp-export"></i> Export
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config
              :moduleName="'FuelInventoryClearingSummaryReport'"
              ref="filterComponent"
              @cancelSelection="cancelAll"
              :allowSameFilter="'allow'"
            ></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p
                v-if="batchProcess"
                class="alert-success p-2"
                id="processFetchBatchMsg"
              >
                Export file is in process. batch no. is {{ batchNum }}.
                <router-link
                  class="color-blue"
                  v-bind:to="{ name: 'BatchList' }"
                  target="_blank"
                  @click.native="batchProcess = 0"
                >
                  Click Here</router-link
                >
                to check file status!
              </p>
              <section class="bg-white data-table">
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange"
                  :moduleName="'FuelInventoryClearingSummaryReport'"
                  :position="'top'"
                >
                </custom-pagination>

                <vue-good-table
                  ref="fuelInventoryClearingSummaryTable"
                  mode="remote"
                  title="Fuel Inventory Clearing Summary Report"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :isLoading="false"
                  :paginationOptions="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    dropdownAllowAll: false,
                    setCurrentPage: listCurrentPage,
                    perPageDropdown: dropDownPerPage,
                  }"
                  :search-options="{
                    enabled: false,
                  }"
                  :sort-options="{
                    enabled: true,
                  }"
                >
                </vue-good-table>
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange"
                >
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>Oops!</h1>
            <h2>403</h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { commonMixins } from "../../mixins/commonMixins";
import { dataTableMixins } from "../../mixins/dataTableMixins";

export default {
  name: "FuelInventoryClearingSummaryReport",
  metaInfo() {
    return {title: "Fuel Inventory Clearing Summary | " +process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins, dataTableMixins],
  data: () => ({
    cantAccessPage: "",
    loading: false,
    pageTitle: "Fuel Inventory Clearing Summary",
    permissions: [],
    rows: [],
    totalRecords: 0,
    userColumns: [],
    columns: [
      {
        label: "Company",
        field: "company",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Company", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "GL Account",
        field: "account_code",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Nat Acct",
        field: "natural_account",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Account Description",
        field: "account_description",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },

      {
        label: "Transaction Amount",
        field: "amount",
        filterable: true,
        fpFieldType: "integer",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Transaction Amount", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Fuel Ticket",
        field: "fuel_ticket",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Fuel Ticket", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Invoice",
        field: "invoice_number",
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Invoice", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "GL Source",
        field: "gl_source_code",
        hidden: false,
        fpFieldType: "text",
        filterable: true,
      },
      {
        label: "Unit Number",
        field: "unit_no",
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: "Ticket Date/ Doc Date",
        field: "ticket_date",
        fpFieldType: "date",
        filterable: true,
        hidden: false,
      },
      {
        label: "Fuel Ticket Status",
        field: "ticket_status",
        filterable: true,
        fpFieldType: "option",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Ticket Status", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ["Entered(E)", "Processed(P)", "Billed(B)"],
          trigger: "enter", //only trigger on enter not on keyup
        },
      },
      {
        label: "Non Bill Code",
        field: "non_bill_code",
        filterable: true,
        fpFieldType: "option",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Non Bill Code", // placeholder for filter input
          filterDropdownItems: [], // initial populated value for this filter
          trigger: "enter", //only trigger on enter not on keyup
        },
        sortable: true,
      },
      {
        label: "Period End Date",
        field: "period_end",
        fpFieldType: "date",
        filterable: false,
        sortable: false,
        fpMandatory: true,
        hidden: true,
      },
    ],
    action: "list",
    batchProcess: 0,
    batchNum: "",
  }),
  watch: {
    permissions: function (permission) {
      var self = this;
      permission.forEach(function (permissions) {
        if (permissions.name == "fuel_inventory_clearing_report") {
          self.cantAccessPage = true;
        }
        if (self.cantAccessPage == "") {
          self.cantAccessPage = false;
        }
      });
    },
  },
  mounted: function () {
    var self = this;
    self.getPermissions();
  },
  created: function () {
    this.serverParams.stopRequest = true;
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.subDayPeriodTable.unselectAllInternal();
    },
    loadList: function () {
      var self = this;
      self.loading = true;

      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/fuel-inventory-clearing-Summary/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
        },
        success: function (data) {
          self.loading = false;

          if (data.status == "success") {
            if (self.action == "export" || self.action == "export_queue") {
              if (data.code == "201") {
                alert(data.message);
              } else {
                if (self.action == "export") {
                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);
                } else {
                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(
            jqXHR,
            true,
            "fuel-inventory-clearing-Summary"
          );
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reports/FuelInventoryClearingSummaryReport.vue